import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts/:accountId/logouts`,
  transformer(data) {
    return data;
  }
};
